export default {
  install (app) {
    app.config.globalProperties.$defaultLocale = process.env.VUE_APP_I18N_DEFAULT_LOCALE;
    app.config.globalProperties.$locales = process.env.VUE_APP_I18N_SUPPORTED_LOCALE;
    app.config.globalProperties.$baseURL = process.env.VUE_APP_BASE_URL;
  }
}